// jQuery(document).ready(function($){
// 	if( $('#shop_page').length && $('.chosen').length){
// 		$('.chosen').each(function(){
// 			var anchor = $(this).find("a").prop("outerHTML");
// 			$('#custom_crumb').append(anchor);
// 		});
// 	}
// });